<template>
  <div v-if="product">
    <div class="product-bubble-wrapper">
      <div v-show="showBubble" class="product-bubble shipping-packing-item-bubble">倉庫に納品済の商品も梱包設定が変更されます。</div>
      <select name="packing-setting-kbn" v-model="product.packingSettingKbn" :id="`packing-setting-kbn-${product.asin}`" class="form-control" @change="update()">
        <option v-for="(arrItem, arrIndex) in arrPackingSettingKbn" :key="arrIndex" :value="arrItem.id">{{ arrItem.name }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showBubble: false,
      arrPackingSettingKbn: [
        {
          id: '0',
          name: '通常梱包で出荷'
        },
        {
          id: '3',
          name: '納品時の梱包のまま出荷'
        }
      ]
    }
  },
  methods: {
    update () {
      this.$emit('update', this.product)
      this.handleShowBubble()
    },
    handleShowBubble () {
      let hasYamatoOffer = this.product.hasYamatoOffer
      let originalPackingSettingKbn = this.product.originalPackingSettingKbn
      let yamatoInventoryQuantity = this.product.yamatoInventoryQuantity
      let packingSettingKbn = this.product.packingSettingKbn
      if (!hasYamatoOffer || yamatoInventoryQuantity < 1) {
        this.showBubble = false
        return
      }

      if (packingSettingKbn !== originalPackingSettingKbn) {
        this.showBubble = true
      } else {
        this.showBubble = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/components/ShippingPackingItem.vue